import type maplibregl from "maplibre-gl";
import type { GeoJSONSourceSpecification, LayerSpecification } from "maplibre-gl";

export function upsertGeoJsonSource(
  map: maplibregl.Map,
  id: string,
  data: GeoJSONSourceSpecification,
) {
  const source = map.getSource(id) as maplibregl.GeoJSONSource | undefined;
  if (source) {
    const sourceData =
      data.data as Parameters<maplibregl.GeoJSONSource["setData"]>[0] | undefined;
    if (sourceData) {
      source.setData(sourceData);
    }
  } else {
    map.addSource(id, data);
  }
}

export function ensureLayer(map: maplibregl.Map, layer: LayerSpecification) {
  if (!map.getLayer(layer.id)) {
    map.addLayer(layer);
  }
}

export function setLayerVisibility(
  map: maplibregl.Map,
  layerId: string,
  visibility: "visible" | "none",
) {
  if (map.getLayer(layerId)) {
    map.setLayoutProperty(layerId, "visibility", visibility);
  }
}
